import { ResiPermissions } from './resi-permissions';
import { resiRouteMatchers } from './resi-routes';

export const resiRouteAccessRules = [
    {
        match: resiRouteMatchers.accessKeys,
        allow: [ResiPermissions.MANAGE_ACCESS_KEY]
    },
    {
        match: resiRouteMatchers.guestsHome,
        allow: [ResiPermissions.VIEW_GUESTS]
    },
    {
        match: resiRouteMatchers.occupantsHome,
        allow: [ResiPermissions.VIEW_OCCUPANTS]
    },
    {
        match: resiRouteMatchers.vehicles,
        allow: [ResiPermissions.VIEW_VEHICLES]
    },
    {
        match: resiRouteMatchers.rentalsHome,
        allow: [ResiPermissions.MANAGE_RENTALS]
    }
];
